<template>
	<div class="h-full bg-bg-grey">
		<div class="hero-image mx-auto mb-8">
			<div class="container">
				<div class="title text-black md:text-white">
					<p class="text-3xl">
						Salut <strong v-if="user.username"> {{ user.username.replace(/ .*/, '') }}</strong>
					</p>
				</div>
			</div>
			<img src="../assets/home.png" class="h-full mx-auto object-cover object-right md:object-center" />
		</div>

		<SingleUserStats v-if="user.rol == 'agent' && user.departamente.length" :user="user" class="container mb-10" />

		<div class="container mb-4">
			<h3 class="text-xl uppercase mb-2">Obiective productie</h3>
		</div>
		<UsersStats v-if="['admin', 'superuser', 'user'].includes(user.rol)" :user="user" class="container mb-10" />

		<section v-if="user.departamente" class="container flex flex-col justify-start gap-10 mb-8">
			<!-- Vanzari Menu -->
			<v-card v-if="user.departamente.includes('vanzari')" class="rounded-lg w-full">
				<div class="w-full h-12 light-grey flex flex-row justify-start items-center px-8">
					<h2 class="text-white text-xl uppercase font-medium">Vanzari</h2>
				</div>
				<v-list class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-1 px-4">
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)" to="/cererisite">
						<v-icon color="primary" class="mr-2">mdi-message-text</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Cereri site</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'agent'].includes(user.rol)" to="/leads">
						<v-icon color="primary" class="mr-2">mdi-account-filter</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Clienti</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)" to="/oferte">
						<v-icon color="primary" class="mr-2">mdi-file-document-multiple</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Ofertare produse</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)" to="/comenzi">
						<v-icon color="primary" class="mr-2">mdi-text-box-check</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Comenzi produse</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)" to="/proforme">
						<v-icon color="primary" class="mr-2">mdi-invoice-text</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Proforme</v-list-item-title>
					</v-list-item>
					<v-list-item
						v-if="user.departamente.includes('vanzari') && ['admin', 'superuser'].includes(user.rol)"
						to="/rapoarte">
						<v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Rapoarte</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-card>
			<!-- Productie Menu -->
			<v-card v-if="user.departamente.includes('productie')" class="rounded-l w-full">
				<div class="w-full h-12 light-grey flex flex-row justify-start items-center px-8">
					<h2 class="text-white text-xl uppercase font-medium">Productie</h2>
				</div>
				<v-list class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-1 px-4">
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent', 'partener'].includes(user.rol)"
						to="/oferte-productie">
						<v-icon color="primary" class="mr-2">mdi-file-document-multiple</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Ofertare garduri</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)" to="/lucrari">
						<v-icon color="primary" class="mr-2">mdi-robot-industrial</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Lucrari</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)"
						:to="isWorksAgent(user) ? '/lucrari/calendar/masuratori' : '/lucrari/calendar/productie'">
						<v-icon color="primary" class="mr-2">mdi-calendar-multiselect</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Calendare lucrari</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)"
						to="/productie/proforme">
						<v-icon color="primary" class="mr-2">mdi-invoice-text</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Proforme garduri</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent', 'partener'].includes(user.rol)"
						to="/productie/contracte">
						<v-icon color="primary" class="mr-2">mdi-file-sign</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Contracte garduri</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'user', 'agent'].includes(user.rol)"
						to="/productie/showroom">
						<v-badge bordered color="blue" :content="String(appointmentsCount.count)"
							:value="appointmentsCount.count > 0" overlap>
							<v-icon color="primary" class="mr-2">mdi-storefront</v-icon>
						</v-badge>
						<v-list-item-title class="text-lg whitespace-normal">Showroom-uri</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser'].includes(user.rol)" to="/productie/rapoarte">
						<v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Rapoarte productie</v-list-item-title>
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser', 'colaborator'].includes(user.rol)"
						to="/productie/oferte-gard/constructii">
						<v-icon color="primary" class="mr-2">mdi-wall</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Oferte zidarie gard</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-card>
		</section>

		<!-- Dev Menu -->
		<section v-if="$isDev && user.rol == 'admin'" class="container flex flex-col justify-start gap-10 mb-8">
			<v-card class="rounded-lg w-full">
				<div class="w-full h-12 light-grey flex flex-row justify-start items-center px-8">
					<h2 class="text-white text-xl uppercase font-medium">Dev</h2>
				</div>
				<v-list class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-1 px-4">
					<v-list-item to="/tests">
						<v-icon color="primary" class="mr-2">mdi-test-tube</v-icon>
						<v-list-item-title class="text-lg whitespace-normal">Tests</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-card>
		</section>
		<!-- <pre>{{ user }}</pre> -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SingleUserStats from '@/components/Dashboard/SingleUserStats.vue';
import UsersStats from '@/components/Dashboard/UsersStats.vue';
import { isWorksAgent } from '@/utils/works';

export default {
	name: "Home",
	components: {
		SingleUserStats,
		UsersStats
	},
	data() {
		return {
			msg: "Homepage",
		};
	},
	computed: {
		...mapState('showrooms', ['appointmentsCount']),
		user() {
			return this.$store.getters.loggedUser;
		}
	},
	methods: {
		isWorksAgent,
		...mapActions('showrooms', ['fetchShowroomAppointmentsCount'])
	},
	mounted() {
		this.fetchShowroomAppointmentsCount();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero-image {
	/* max-width: 1920px; */
	/* background-color: #f2f4f8; */
	@apply bg-main-grey relative h-96 md:h-80
}

.hero-image .title {
	/* color: #ffffff; */
	/* position: absolute; */
	/* top: 50%; */
	/* left: 50%; */
	/* transform: translate(-50%, -50%); */
	/* text-shadow: 0px 4px 7px rgba(0, 0, 0, 0.21); */
	/* margin: 0; */
	@apply absolute top-1/3
}

/*
.top {
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/ss3.jpg');
  background-repeat: no-repeat;
} */
</style>
